(function($) {

  // Header -> Collapse Menu

	$('#sidebarCollapse').on('click', function () {
        // open sidebar
        $('#sidebar-menu').addClass('active');
        // fade in the overlay
        $('.overlay').fadeIn();
        //$('.collapse.in').toggleClass('in');
        //$('a[aria-expanded=true]').attr('aria-expanded', 'false');
    });

   
    // if dismiss or overlay was clicked
    $('#dismiss, #all-nav .overlay').on('click', function () {
      // hide the sidebar
      $('#sidebar-menu').removeClass('active');
      // fade out the overlay
      $('.overlay').fadeOut();
    });


    // Home -> Carousel

    $('#carousel').slick({
      'autoplay':       true,
      'autoplaySpeed':  6000,
      'arrows':         true,
      'fade':           true,
      'pauseOnHover':   false
    });  


    // Home -> slider

    $('#products-slider').slick({
      autoplay:       false,
      arrows:         true,
      slidesToShow: 5,
      slidesToScroll: 5,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });  



    // Défaults FancyBox

    $.fancybox.defaults.loop = true;

    $.fancybox.defaults.buttons = [
        "zoom",
        //"share",
        //"slideShow",
        //"fullScreen",
        //"download",
        //"thumbs",
        "close"
    ];



    // Product Pointures

   /*$('#pa_pointure').imagepicker({
      hide_select : true,
      show_label  : true
    });*/

})( jQuery );